import System from '../System';
import StateManager from 'State/StateManager';
import { TGameArea } from 'Utility/Tracking/DataSet/Transaction';
import Game from 'Game';
import { IGameState } from 'State/Game/IGameState';
import { PlayMusic } from '../Audio/AudioHelper';
import GameObject from 'GameObject/GameObject';
import { track } from 'Utility/Tracking/Track';
import { preload as preloadWorldSystem } from '../World/WorldSystemHelper';
import { AUDIO_CLIP_MUSIC, queueMyPetMiniGameResources, } from './MyPetMiniGameSystemHelper';
import { MyPetMiniGameUI } from 'Prototype/MyPetMiniGame/MyPetMiniGameUI';
import { getMyPetMiniGameJackpotReward, getRandomPetMinigameRewards, } from './MyPetMiniGameRewards';
import { IRewardData } from 'Utility/RewardHelper';
import { GameActions } from 'State/Game/GameActions';
import { MyPetMiniGameActions } from 'State/MyPetMiniGame/MyPetMiniGameActions';
import { InventoryStateHelper } from 'State/Player/Inventory/InventoryStateHelper';

type RewardData = IRewardData & { isJackpot?: boolean };

type MyPetMiniGameSystemProps = {
    state: StateManager;
    forceJackpotWin: boolean;
}

// TODO: consider using the BaseUIHandler (and turning this into MyPetMiniGameUISystem)
export default class MyPetMiniGameSystem extends System {
    private myPetMiniGameUI: MyPetMiniGameUI | undefined;
    private rewards: RewardData[];
    private readonly props: MyPetMiniGameSystemProps;

    constructor(props: MyPetMiniGameSystemProps) {
        super(props.state);

        this.props = props;

        track('tGameArea', TGameArea.MY_PET_MINI_GAME);
    }

    public init(): void { }

    public async preload() {
        console.log('My Pet Mini Game System beginning to preload');

        queueMyPetMiniGameResources();

        await Game.resource.load();

        console.log('My Pet Mini Game System done preloading');
    }

    public onStart(): void {
        const state = Game.store.getState();

        this.rewards = getRandomPetMinigameRewards(
            9,
            InventoryStateHelper.getRestrictedBoosters(state.playerState)
        );

        const jackpotIndex = this.rewards.findIndex((r) => r.isJackpot);

        if (this.props.forceJackpotWin) {
            if (jackpotIndex === -1) {
                this.rewards[0] = getMyPetMiniGameJackpotReward();
            } else {
                [this.rewards[0], this.rewards[jackpotIndex]] = [this.rewards[jackpotIndex], this.rewards[0]];
            }
        } else {
            if (
                jackpotIndex === -1
            ) {
                const randomIndex =
                    1 + Math.floor(Math.random() * (this.rewards.length - 1));
                this.rewards[randomIndex] = getMyPetMiniGameJackpotReward();
            }
        }

        preloadWorldSystem(state.playerState.maxWorld);

        this.myPetMiniGameUI = GameObject.Instantiate(MyPetMiniGameUI, {});
        this.scene.addGameObject(this.myPetMiniGameUI);

        this.myPetMiniGameUI.onDiggingClick(this.handleItemClick);
        this.myPetMiniGameUI.onClaimClick(this.handleClaimClick);

        PlayMusic(AUDIO_CLIP_MUSIC);

        this.myPetMiniGameUI.setItemsInput(false);
        this.myPetMiniGameUI.presentItems()
            .then(() => {
                this.myPetMiniGameUI.setItemsInput(true);
            });
    }

    protected onStop(): void { }

    protected onDestroy(): void { }

    protected onUpdate(): void { }

    protected onLateUpdate(): void { }

    public handleStateChanged(state: IGameState) {
        // TO DO
    }

    private handleItemClick = async (index: number): Promise<void> => {
        [this.rewards[0], this.rewards[index]] = [
            this.rewards[index],
            this.rewards[0],
        ];

        MyPetMiniGameActions.claimRewards([this.rewards[index]]);

        const selectedReward = this.rewards[index];
        this.myPetMiniGameUI.setItemsInput(false);
        await this.myPetMiniGameUI.movePetToItem(index);
        this.myPetMiniGameUI.addRewards(this.rewards, index);
        await this.myPetMiniGameUI.animateDiggingItem(index);
        await this.myPetMiniGameUI.revealSelectedReward(index);
        await this.myPetMiniGameUI.revealRewards(index);

        await this.myPetMiniGameUI.showClaimButton();
    };

    private handleClaimClick = (): void => {
        this.myPetMiniGameUI.disableClaimButton();

        const petSpawnLevel = Game.store.getState().worldState.petSpawnLevel;
        GameActions.loadWorld({
            petSpawnLevel
        });
    };
}
